import { useClickRef } from '@make-software/csprclick-ui';
import { useEffect, useState, useCallback } from 'react';

import type { ActiveAccountType, CsprClickEvent } from 'types';
import type { ICsprCloudProxy } from '@make-software/csprclick-core-types';

// use only in App.tsx
export const useCsprClick = () => {
  const clickRef = useClickRef();
  const [activeAccount, setActiveAccount] = useState<ActiveAccountType | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isClickLoaded, setIsClickLoaded] = useState<boolean>(false);

  const signIn = () => {
    clickRef?.signIn();
  };

  const buyCSPR = () => {
    return clickRef?.showBuyCsprUi();
  };

  // Get CSPR.cloud proxy for authenticated API requests
  const getCsprCloudProxy = useCallback((): ICsprCloudProxy | null => {
    return clickRef?.getCsprCloudProxy() || null;
  }, [clickRef]);

  useEffect(() => {
    if (clickRef) {
      setIsClickLoaded(true);
    }
  }, [clickRef]);

  useEffect(() => {
    clickRef?.on('csprclick:signed_in', async (evt: CsprClickEvent) => {
      await setActiveAccount(evt.account);
      await setIsInitialized(true);
    });
    clickRef?.on('csprclick:switched_account', async (evt: CsprClickEvent) => {
      await setActiveAccount(evt.account);
      await setIsInitialized(true);
    });
    clickRef?.on('csprclick:signed_out', async () => {
      setActiveAccount(null);
      await setIsInitialized(true);
    });
    clickRef?.on('csprclick:disconnected', async () => {
      setActiveAccount(null);
      await setIsInitialized(true);
    });
  }, [clickRef, clickRef?.on]);

  return {
    activeAccount,
    isInitialized,
    signIn,
    buyCSPR,
    clickRef,
    isClickLoaded,
    getCsprCloudProxy,
  };
};
